'use strict';

const h = require('phy');
const SelectLogo = require('./image_logo');

const Information = props => {
  const {
    dealProps,
    touchRequest,
    hideByDefault = true,
    appliedAtCheckoutText,
  } = props;

  if (dealProps.soldOutOrExpired) {
    return null;
  }

  let classList = '.select-widget';
  if (touchRequest) {
    classList += '.t-pod';
  } else if (dealProps.isGetawaysDeal) {
    classList += '.select-widget_getaways';
  }
  if (hideByDefault) {
    classList += '.hide';
  }

  const bodyHtml = `<span> ${appliedAtCheckoutText} </span>`;

  return h(
    `div${classList}#select-widget-information`,
    {
      'data-bhw': 'SelectInformationWidget',
      'data-bh-viewport': 'respect',
    },
    h(SelectLogo, props),
    h('p.select-widget__body', {
      dangerouslySetInnerHTML: { __html: bodyHtml },
    })
  );
};
module.exports = Information;
